import { render, staticRenderFns } from "./ApfLanguageSection.vue?vue&type=template&id=1fc8e3ee&scoped=true"
import script from "./ApfLanguageSection.vue?vue&type=script&lang=js"
export * from "./ApfLanguageSection.vue?vue&type=script&lang=js"
import style0 from "./ApfLanguageSection.vue?vue&type=style&index=0&id=1fc8e3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8e3ee",
  null
  
)

export default component.exports